import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import uuid from "uuid/v1";
import Input from "../componentes/Input.jsx";
import ButtonLogin from "../componentes/ButtonLogin.jsx";
import Row from "../componentes/Row.jsx";
import Api from "../../utils/Api.jsx";
import Cookies from "../../lib_react_frontend/utils/Cookies.jsx";
import ApiceFadeIn from "../../lib_react_frontend/componentes/ApiceFadeIn.jsx";
import "./login.css";

/**
 * Tela de login padrão utilizada nos sistemas, é possível passar uma cor
 * para ele de forma a customizar ela.
 */
class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      login: "",
      senha: "",
      uuid: uuid(),
    };

    // Padrão do LTE:
    document.body.className = "hold-transition login-page";
  }

  /**
   * @override
   */
  componentDidMount() {
    // Foca o input do login:
    this.inputLogin.focus();
    // Faz a tela aparecer lentamente:
    this.apiceFadeIn.fadeIn();
  }

  /**
   * Trata as validações antes de realizar o login.
   */
  realizarValidacoes() {
    if (!this.state.login) {
      this.inputLogin.focus();
      toastr.error("Atenção!", "Informe o login!");
      return;
    }
    return true;
  }

  async realizarRegistro() {
    toastr.error("Aaaa");
  }

  /**
   * Realiza o login no backend.
   */
  async realizarLogin() {
    if (!this.realizarValidacoes()) {
      return;
    }

    let ret;
    try {
      ret = await Api.login(this.state.login.toUpperCase(), this.state.senha);

      if (ret.status) {
        // Sucesso no login!
        const dezAnos = new Date(
          new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 10
        );
        Cookies.set(global.app.cookie, ret.dados.token, dezAnos);
        this.props.history.push(global.app.options.landingPage || "/app");
      } else {
        toastr.error("Atenção!", ret.erro.error_message);
      }
    } catch (ex) {
      toastr.error("Erro!", "Provavelmente há um erro!");
    }
  }

  render() {
    return (
      <ApiceFadeIn ref={(e) => (this.apiceFadeIn = e)}>
        <div className="formulario">
          <div className="form_b1" />
          <div className="form_b2">
            <div className="apiceStart">
              <div className="apiceStart-icon">
                <i className={"fa rxzz " + global.app.icone} />
              </div>
              <div className="apiceStart-titulo">
                <b>ERP-BI</b>
              </div>
            </div>
            {/* Login: */}
            <div className="form-group has-feedback ">
              <Input
                className="format_input"
                placeholder="Digite seu login"
                value={this.state.login}
                ref={(e) => (this.inputLogin = e)}
                onKeyEnter={() => this.inputSenha.focus()}
                onChange={(e) => this.setState({ login: e.target.value })}
                name={this.state.uuid}
                autoComplete
              />
              <i className="fa fa-sign-in form-control-feedback" />
            </div>

            {/* Senha: */}
            <div className="form-group has-feedback">
              <Input
                className="format_input"
                placeholder="Digite sua senha"
                value={this.state.senha}
                ref={(e) => (this.inputSenha = e)}
                onChange={(e) => this.setState({ senha: e.target.value })}
                onKeyEnter={this.realizarLogin.bind(this)}
                uppercase={false}
                type="password"
                autoComplete
              />
              <i className="fa fa-lock form-control-feedback" />
            </div>

            {/* Linha de realizar login: */}
            <Row>
              <div className="">
                <ButtonLogin
                  icon="fa-sign-in"
                  label="Entrar"
                  className="botaoLogin"
                  onClick={this.realizarLogin.bind(this)}
                />
              </div>
            </Row>
            {/* <a href="./recuperarsenha" target="_blank" className="txRecSenha">
              Esqueci minha senha
            </a> */}
          </div>

          <div className="login-text">
            <p style={{ fontSize: "10px", textAlign: "center" }}>{}</p>
          </div>
        </div>
      </ApiceFadeIn>
    );
  }
}

export default connect(
  (state) => ({
    socket: state.socket,
  }),
  (dispatch) => ({
    dispatch,
  })
)(Login);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/Login.jsx